import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon, Volume2Icon, SparklesIcon, EyeOffIcon } from 'lucide-react';
export function WhyItFailed() {
  const reasons = [{
    icon: AlertTriangleIcon,
    text: 'La lavandina y el amoníaco contienen componentes que le dicen al gato "orina aquí de nuevo" para reforzar su olor.'
  }, {
    icon: Volume2Icon,
    text: 'Los gritos y castigos elevan el cortisol del gato, haciendo que marque MÁS para sentirse seguro en su territorio.'
  }, {
    icon: SparklesIcon,
    text: 'Las arenas perfumadas huelen bien para vos, pero son una explosión química insoportable para el olfato superior de tu gato.'
  }, {
    icon: EyeOffIcon,
    text: 'Limpiar "por encima" no elimina el ácido úrico, que queda como un faro de neón invisible para los ojos humanos.'
  }];
  return <section className="w-full bg-white py-10 md:py-20 px-6" data-id="element-478">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-4xl mx-auto" data-id="element-479">
        <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-bold text-[#1C1C1C] mb-4 text-center" data-id="element-480">
          Por qué lo que probaste no funcionó
        </h2>
        <p className="text-lg text-[#1C1C1C]/70 mb-12 text-center" data-id="element-481">
          No es tu culpa. Estos son los errores más comunes:
        </p>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-482">
          {reasons.map((reason, index) => {
          const Icon = reason.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="bg-[#E8F0E8] p-6 rounded-lg" data-id="element-483">
                <Icon className="w-8 h-8 text-[#8B4513] mb-4" data-id="element-484" />
                <p className="text-[#1C1C1C] leading-relaxed" data-id="element-485">{reason.text}</p>
              </motion.div>;
        })}
        </div>
      </motion.div>
    </section>;
}